import axios from "axios";
import { getBaseUrl } from "redux/utils";
export function getPatientSummary(patientId, practiceId) {
  let api_url = getBaseUrl();
  return axios.get(
    `${api_url}/demographics/patient_summary.json`,
    { params: { pid: patientId, practice_id: practiceId } }
  );
}

export function addProblem(problems) {

  return axios.put("http://localhost:3000/v1/problems/updatePatientProblem", problems);
}

export function getPatientAllergies(patientId, practiceId) {
  let api_url = getBaseUrl();
  if (patientId || practiceId) {
    return axios.get(
      `${api_url}/prescriptions/ds_patient_allergies.json`,
      { params: { pid: patientId, practice_id: practiceId } }
    );
  }
}

export const allergiesQueryConstructor = (collection, patientId) =>
  collection.findOne().where("pid").equals(patientId);

export function addAllergiesIntoDB(patientId, response, collection) {
  const {
    data: {
      response: { data },
    },
  } = response;

  const allergies = data.map((allergy) => {
    return {
      id: allergy.id,
      name: allergy.name,
      code: allergy.code,
      code: allergy.code_type,
      reaction: allergy.reaction,
      reaction_code: allergy.reaction_code,
      reaction_type: allergy.reaction_type,
      severity: allergy.severity,
      severity_code: allergy.severity_code,
    };
  });

  collection.insert({
    pid: patientId,
    allergies: allergies,
  });
}

export function getPatientProblems(patientId) {
  let api_url = getBaseUrl();
  return axios.get(
    `${api_url}/ccm/get_health_conditions.json`,
    { params: { pid: patientId } }
  );
}

export function getHealthConcerns(patientId) {
  let api_url = getBaseUrl();
  return axios.get(
    `${api_url}/health/get_concerns.json`,
    { params: { pid: patientId } }
  );
}

export function addProblemsIntoDB(problem) {
  let api_url = getBaseUrl();
  return axios.post(`${api_url}/ccm/add_patient_health_conditions.json`,
    { ...problem });
}

export function getPatientMedications(patientId, practiceId) {
  let api_url = getBaseUrl();
  return axios.get(
    `${api_url}/prescriptions/ds_patient_medications.json`,
    { params: { pid: patientId, practice_id: practiceId } }
  );
}

export function addPatientMedicationsIntoDB(patientId, response, collection) {
  const {
    data: {
      response: { data },
    },
  } = response;

  const medications = data.map((medication) => {
    return {
      id: medication.id,
      name: medication.name,
      code: medication.code,
      code: medication.code_type,
      reaction: medication.reaction,
      reaction_code: medication.reaction_code,
      reaction_type: medication.reaction_type,
      severity: medication.severity,
      severity_code: medication.severity_code,
    };
  });

  collection.insert({
    pid: patientId,
    medications: medications,
  });
}
